//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import { getNewsDetail,getNewsReadCount} from '@/api/qf'
export default {
    data() {
        return {
            newsId:'',
            newsInfo:{},
            newsVideo:{},
          countInfo:{},
          kh:0
        };
    },
    methods: {
        get_news_detail(){
            let params = {newsId:this.newsId}
            getNewsDetail(params).then((res) => {
                this.newsInfo = res.data;
                this.newsVideo = this.newsInfo.newsVedio;
                document.title = this.newsInfo.title;
                if(this.newsInfo.isEnglish){
                  $("#body").css({"text-align": "left"});
                }else{
                  $("#body").css({"text-align": "justify"});

                }
            })
        },
      getNewsReadCount(){
        let params = {newsId:this.newsId}
        getNewsReadCount(params).then((res) => {
          this.countInfo = res
        })
      },





    },

    mounted () {
        this.newsId = this.$route.query.newsId;
      this.kh = this.$route.query.kh;
        this.get_news_detail();
      this.getNewsReadCount();
    }
}



// WEBPACK FOOTER //
// ./src/pages/qf/video_detail.vue